var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg9Doge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7791 2.00074H4.55309V10.9038H1.99756V13.0848H4.55378V21.9872H11.8047C11.8047 21.9872 22 22.776 22 12.1616C22.0028 1.71844 12.2516 2.00074 10.7791 2.00074ZM11.6411 18.2919H8.63993V13.0835H13.1408V10.9032H8.63993V5.69479H11.501C12.5706 5.69479 17.9538 6.09275 17.9629 12.2327C17.972 18.3726 12.4119 18.2925 11.6424 18.2925L11.6411 18.2919Z",
    fill: "#C2A633"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg9Doge);
export default __webpack_public_path__ + "static/media/9.DOGE.1872aa35e614883e4b86c83d30c7a289.svg";
export { ForwardRef as ReactComponent };